import React, { Component } from 'react';
import './styles.scss';
import { Field } from 'redux-form';
import { HorizontalFormControl, NameFields } from '../../../../common/components';
import { Col, Row, FormGroup, ControlLabel } from 'react-bootstrap';
import ButtonGroup from '../../../brokerApplication/components/BrokerApplicationForm/components/ReduxFormFields/ButtonGroup';
import Select from 'react-select';
import selectTheme from '../../../../helpers/selectTheme';

export default class Directors extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { fields } = this.props;
    if (fields.length === 0) {
      fields.push();
    }
  }
  handleDirectorCountChange(option) {
    const { fields } = this.props;
    const noOfDirectors = option.value;
    if (noOfDirectors > fields.length) {
      for (let i = fields.length; i < noOfDirectors; i++) {
        fields.push();
      }
    }
    if (noOfDirectors < fields.length) {
      fields.splice(noOfDirectors, fields.length);
    }
  }

  render() {
    const { fields } = this.props;
    return (
      <div>
        <div className="directors">
          <Row>
            <Col sm={8}>
              <FormGroup>
                <Col sm={2}>
                  <ControlLabel>No. Directors</ControlLabel>
                </Col>
                <Col sm={6}>
                  <Select
                    theme={(theme) => selectTheme(theme)}
                    options={noOfDirectorOptions}
                    value={noOfDirectorOptions.find((option) => {
                      return option.value === fields.length;
                    })}
                    onChange={(option) => this.handleDirectorCountChange(option)}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>

          {fields.map((insured, index) => {
            return (
              <Row key={index}>
                <Col sm={12} className="directors-container">
                  <Row>
                    <Col
                      sm={12}
                      key={index}
                      className={'director-row director' + index + ' adult'}
                    >
                      <h4 className={'director-header-number'}>
                        <strong>Director {index + 1}</strong>
                      </h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <div className="director-name-field">
                        <NameFields
                          baseName={insured}
                          label="Name"
                          labelSize={2}
                          fieldComponent={Field}
                          fieldSize={10}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Field
                    name={`data.attributes.metadata.directors[${index}].position_and_year`}
                    fieldSize={6}
                    component={HorizontalFormControl}
                    labelSize={2}
                    label="Position & Year of appointment"
                  />
                  <Field
                    name={`data.attributes.metadata.directors[${index}].individual_fca_number`}
                    fieldSize={6}
                    component={HorizontalFormControl}
                    labelSize={2}
                    label="Individual FCA Number"
                  />

                  <FormGroup>
                    <Col sm={9}>
                      <ControlLabel>Actively involved?</ControlLabel>
                    </Col>
                    <Col sm={3}>
                      <div className={'broker-application-answers'}>
                        <Field
                          name={`data.attributes.metadata.directors[${index}].actively_involved.answer`}
                          label="Actively involved?"
                          component={ButtonGroup}
                          inline
                          options={[
                            { label: 'Yes', value: true },
                            { label: 'No', value: false },
                          ]}
                        />
                      </div>
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            );
          })}
        </div>
      </div>
    );
  }
}

const noOfDirectorOptions = [
  { value: 1, label: 'One' },
  { value: 2, label: 'Two' },
  { value: 3, label: 'Three' },
  { value: 4, label: 'Four' },
  { value: 5, label: 'Five' },
  { value: 6, label: 'Six' },
];
